import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, IconButton, Typography, styled, useTheme, useMediaQuery } from '@mui/material';
import LocalPharmacyOutlinedIcon from '@mui/icons-material/LocalPharmacyOutlined';
import PersonSearchOutlinedIcon from '@mui/icons-material/PersonSearchOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import LocalHospital from '@mui/icons-material/LocalHospital';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import { HouseOutlined, PersonAdd } from '@mui/icons-material';

const ActionButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%', // Take full width on mobile
}));

const ActionTitle = styled(Typography)(({ theme }) => ({
  variant: 'h6',
  color: theme.palette.grey[800],
  fontWeight: theme.typography.fontWeightSemiBold,
  marginBottom: theme.spacing(3), // Adjusted margin for smaller screens
  textAlign: 'center', // Center the title on mobile
}));

const ActionsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-around',
  width: '100%',
  maxWidth: theme.spacing(64),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'row', // Keep icons in a row on smaller screens
    justifyContent: 'space-between',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  [theme.breakpoints.down('xs')]: {
    flexDirection: 'column', // Stack icons on very small screens
    alignItems: 'center',
    gap: theme.spacing(2),
  },
}));

const SingleAction = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  [theme.breakpoints.down('xs')]: {
    width: '100%', // Make each action take full width on very small screens
  },
}));

const ActionIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: '#E8F5E9', // Light green
  color: '#4CAF50', // Green 500
  borderRadius: '50%', // Make the background round
  padding: theme.spacing(2), // Adjusted padding for smaller screens
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2),
  },
}));

const ActionLabel = styled(Typography)(({ theme }) => ({
  variant: 'caption',
  color: theme.palette.grey[600],
  marginTop: theme.spacing(1),
  textAlign: 'center',
}));

const LandingActionButtons = () => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));

  const navigate = useNavigate();

  const actions = [
    { icon: <LocalHospital />, label: 'Hospital', onClick: () => navigate('/care-givers?nn=5') },
    { icon: <PersonAdd />, label: 'Doctor', onClick: () => navigate('/doctors') },
    { icon: <LocalPharmacyOutlinedIcon />, label: 'Pharmacy', onClick: () => navigate('/care-givers?nn=2') },
    { icon: <HouseOutlined />, label: 'Lab', onClick: () => navigate('/care-givers?nn=4') },
    // { icon: <CreditCardOutlinedIcon />, label: 'Pay', onClick: () => console.log('Pay Clicked') },
    { icon: <PersonSearchOutlinedIcon />, label: 'Care Giver', onClick: () => navigate('/care-givers') },
  ];



  return (
    <ActionButtonContainer>
      <ActionTitle>
        What will you like to do today?
      </ActionTitle>
      <ActionsWrapper>
        {actions.map((action) => (
          <SingleAction key={action.label}>
            <ActionIconButton onClick={action.onClick} size={isXs ? 'large' : 'medium'}>
              {action.icon}
            </ActionIconButton>
            <ActionLabel>
              {action.label}
            </ActionLabel>
          </SingleAction>
        ))}
      </ActionsWrapper>
    </ActionButtonContainer>
  );
};

export default LandingActionButtons;